import idioma from "../../idioma/index.js";

const state = () => ({
  sIdiomaPred: "es", // Indica el idioma predefinido
  oEquivalencias: idioma["es"], // Equivalencias de palabras claves almacenadas
});

const getters = {
  getsIdiomaPred: (state) => {
    return state.sIdiomaPred;
  },
  getCargando: (state) => {
    return state.cargando;
  },
};

const mutations = {
  SETEQUIVALENCIASIDIOMA: (state, value) => {
    state.oEquivalencias = idioma[value];
  },
};

const actions = {
  setEquivalenciasIdioma({ commit }, value) {
    commit("SETEQUIVALENCIASIDIOMA", value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
